import styled from 'styled-components'
import { ReactComponent as CloseIconSvg } from 'presentation/assets/icons/close.svg'

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const CloseIcon = styled(CloseIconSvg)`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2.5rem;

  button {
    flex: 1;
  }
`
